// extracted by mini-css-extract-plugin
export var dateContainer = "CruiseItineraryItem-module--date-container--00d99";
export var excursions = "CruiseItineraryItem-module--excursions--32f8b";
export var expand = "CruiseItineraryItem-module--expand--7f5ae";
export var overnightIcon = "CruiseItineraryItem-module--overnight-icon--c9183";
export var stopWorldLocation = "CruiseItineraryItem-module--stop-world-location--dd282";
export var title = "CruiseItineraryItem-module--title--77791";